module.exports = __webpack_public_path__ + "static/media/four-creativities.6dd5c587.svg";